<div [ngClass]="open ? 'searchFilter slide-bottom' : 'slide-top searchFilter'">
  <!-- *ngIf="open" -->
  <div class="row">
    <form [formGroup]="form">
      <!-- <div class="col-12 selecDiv">
        <p>Nivel de riesgo</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select formControlName="levelRisk">
            <mat-option
              *ngFor="let levelRisk of riskLevels"
              [value]="levelRisk.name"
              >{{ levelRisk.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div> -->
      <div class="col-12 selecDiv">
        <p>Tipo</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select formControlName="type">
            <mat-option *ngFor="let type of optionTextSearch" [value]="type">{{
              type
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 selecDiv">
        <p>Unidad</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select formControlName="unit">
            <mat-option *ngFor="let unit of units" [value]="unit">{{
              unit.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 selecDiv">
        <p>Tipo de caso</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select
            formControlName="caseType"
            [disabled]="form.value.unit ? false : true"
          >
            <mat-option
              *ngFor="let caseType of form.value.unit?.ct"
              [value]="caseType._id"
              >{{ caseType.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 selecDiv">
        <p>Fecha</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select formControlName="date">
            <mat-option *ngFor="let d of dates" [value]="d.value">{{
              d.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 selecDiv">
        <p>Responsable</p>
        <mat-form-field class="matform" appearance="standard">
          <mat-select formControlName="assigned">
            <mat-option *ngFor="let user of users" [value]="user._id">{{
              user.fullname
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
    <div class="col-6 right">
      <button mat-button class="btnth" (click)="search()">Buscar</button>
    </div>
    <div class="col-6 left">
      <button mat-button class="btnthRestore" (click)="cleanFilter()">
        Restablecer
      </button>
    </div>
  </div>
</div>
